import React from "react";

const SliderSection = () => {
  const responsive = {
    0: { items: 1 }
};
  return (
    <>
      <div
        id="carouselExampleIndicators"
        class="carousel slide  carsoleHeight"
        data-ride="carousel"
        style={{
          backgroundImage:
            "linear-gradient(to bottom, #010102,#020204,#07070B,#2B2D41 )",
          height: 380,
        }}
      >
        <ol class="carousel-indicators">
          <li
            data-target="#carouselExampleIndicators"
            data-slide-to="0"
            class="active"
          ></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
        </ol>
        <div
          class="carousel-inner carsoleHeight"
          style={{
            display: "flex",
            alignItems: "center",
            height: 380,
          }}
        >
          <div class="carousel-item active">
            <div
            className="carouselMain"
              style={{
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px 0px",
              }}
            >
              <div  className="carouselText" style={{ marginRight: "60px", minWidth: "500px" }}>
                <div
                   className="carouselImageLeft" 
                  style={{
                    color: "white",
                    textAlign: "start",
                  }}
                >
                  <img src="../images/Top.png"></img>
                </div>
                <div
                className="carouselText"
                  style={{
                    color: "white",
                    textAlign: "left",
                    fontSize: "24px",
                    paddingLeft:40
                  }}
                >
                My employees love the Bond perks and benefits <br/> they get access to. Bond is a great way to engage <br/> and build community outside of the workplace.
                </div>
                <div
                  className="carouselImageRight" 
                  style={{
                    color: "white",
                    textAlign: "end",
                  }}
                >
                  <img src="../images/Bottom.png"></img>
                </div>
              </div>
              <div  className="carouselImage">
                <img src="../images/Person_Image.png"></img>
                <div
                  style={{
                    color: "white",
                    textAlign: "center",
                    fontSize: "24px",
                    marginTop: "15px",
                  }}
                >
                  Kathy Stevenson
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-item ">
            <div
            className="carouselMain"
              style={{
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px 0px",
              }}
            >
              <div  className="carouselText" style={{ marginRight: "60px", minWidth: "500px" }}>
                <div
                  style={{
                    color: "white",
                    textAlign: "start",
                  }}
                >
                  <img src="../images/Top.png"></img>
                </div>
                <div
                className="carouselText"
                  style={{
                    color: "white",
                    textAlign: "left",
                    fontSize: "24px",
                    paddingLeft:40
                  }}
                >
                Bond saved so much time and effort. We had a blast <br/> the whole evening! Subscribe to Bond and you have the <br/> hidden gems of California in your phone.
                </div>
                <div
                  style={{
                    color: "white",
                    textAlign: "end",
                  }}
                >
                  <img src="../images/Bottom.png"></img>
                </div>
              </div>
              <div  className="carouselImage">
                <img src="../images/Person_Image_Two.png"></img>
                <div
                  style={{
                    color: "white",
                    textAlign: "center",
                    fontSize: "24px",
                    marginTop: "15px",
                  }}
                >
                 Naomi Perch 
                </div>
              </div>
            </div>
          </div>
          <div class="carousel-item ">
            <div
            className="carouselMain"
              style={{
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px 0px",
              }}
            >
              <div  className="carouselText" style={{ marginRight: "60px", minWidth: "500px" }}>
                <div
                  style={{
                    color: "white",
                    textAlign: "start",
                  }}
                >
                  <img src="../images/Top.png"></img>
                </div>
                <div
                className="carouselText"
                  style={{
                    color: "white",
                    textAlign: "left",
                    fontSize: "24px",
                    paddingLeft:40
                  }}
                >
               I've always had such a struggle coming up with <br/> date ideas. Bond perfected my date in a beautiful <br/> venue and amazingly detailed service.
                </div>
                <div
                  style={{
                    color: "white",
                    textAlign: "end",
                  }}
                >
                  <img src="../images/Bottom.png"></img>
                </div>
              </div>
              <div  className="carouselImage">
                <img src="../images/Person_Image_Three.jpeg" height="202px"></img>
                <div
                  style={{
                    color: "white",
                    textAlign: "center",
                    fontSize: "24px",
                    marginTop: "15px",
                  }}
                >
                  James Woodhill
                </div>
              </div>
            </div>
          </div>
         
        </div>
        <a
          class="carousel-control-prev"
          href="#carouselExampleIndicators"
          role="button"
          data-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a
          class="carousel-control-next"
          href="#carouselExampleIndicators"
          role="button"
          data-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
     
    </>
  );
};

export default SliderSection;
